import React from 'react'
import ExpenseCategories from 'src/app/ExpenseCategories/ExpenseCategories'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expenseCategoriesRouteProps } from 'src/navigation/routeProps'

const ExpenseCategoriesAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseCategories,
  routeProps: expenseCategoriesRouteProps,
  component: <ExpenseCategories />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseCategoriesAppRoute
